import ApplicationController from '../application_controller'
import { put } from '@rails/request.js'

class EventTypesController extends ApplicationController {
  toggle (e) {
    const url = e.target.dataset.url
    const checked = e.target.checked
    const unitId = e.target.dataset.unitId

    put(url,
      {
        body: {
          checked,
          unit_id: unitId
        }
      }
    )
  }
}

export default EventTypesController
